import { useDataSubmit, useDataValue, useDataChange } from 'Simple/Data.js'

export function isTagSelected(tag_id, task_tags) {
  return task_tags.some(({ tag }) => tag.id === tag_id)
}

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  let task_tags = useDataValue({
    context: 'task',
    path: 'task_tags',
    viewPath: props.viewPath,
  })

  let changeSearchTerm = useDataChange({
    context: 'tags_picker',
    path: 'search_term',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let should_remove = isTagSelected(value.id, task_tags)

    submit({
      type: 'set_task_tags',
      task_id,
      tag_ids: should_remove
        ? task_tags
            .filter(({ tag }) => tag.id !== value.id)
            .map(({ tag }) => tag.id)
        : [...task_tags.map(({ tag }) => tag.id), value.id],
    })

    changeSearchTerm('')
  }
}

export function useOnClickEdit(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'open_edit_tag',
      value,
    })
  }
}
